// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"545":"8cc85b3c","554":"4c6c2115"}[chunkId] + ".chunk.css";
};